import { StackAtom, TextBoxMolecule } from '@justomx/atlas-components'
import { TextAreaMolecule } from 'components/molecules/TextArea.molecule';
export type InventoryAttributes = 'quantity' | 'lot' | 'expiration' | 'description'

interface CreateInventoryProductOrganismProps {
  onChange: (attribute: InventoryAttributes, value: string) => void
  description: string
}

export const CreateInventoryProductOrganism = ({ description, onChange }: CreateInventoryProductOrganismProps) => {
  const _onChange = (attribute: InventoryAttributes) => (value: string) => { onChange(attribute, value) }

  return <StackAtom gap={20} >
    <TextBoxMolecule label='Cantidad' type='number' onChange={_onChange('quantity')}/>
    <TextBoxMolecule label='Lote' onChange={_onChange('lot')}/>
    <TextBoxMolecule label='Caducidad' type='date' onChange={_onChange('expiration')}/>
    <TextAreaMolecule
      label='Motivo'
      value={description}
      onChange={_onChange('description')}
      supportingText='Escribe mínimo 10 caracteres y máximo 140.'
    /> 
  </StackAtom>
}
